import * as React from 'react';
import { Col, Row, Divider, Input, Select, Checkbox } from 'antd';

import Form, { FormItem, ColorInput } from '../../../components/Form';
import { Title } from '../../../components/Layout/components';

interface IProductTagDetailProps {
  domain: string;
  productTag: GQL.IProductTag;
  languages: Array<GQL.ILanguage>;
  onSave: (productTag: GQL.IProductTag) => void;
  onCancel: () => void;
}

interface IProductTagDetailState {
  productTag: GQL.IProductTag;
  currentLanguage: string;
}

export default class DeliveryMethodDetail extends React.Component<IProductTagDetailProps, IProductTagDetailState> {

  public constructor(props: IProductTagDetailProps) {
    super(props);

    this.state = {
      productTag: props.productTag || {},
      currentLanguage: props.languages.map(l => l.value)[0],
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { languages } = this.props;
    const { productTag, currentLanguage } = this.state;

    return (
      <div>
        <Title
          languages={languages}
          currentLanguage={this.state.currentLanguage}
          onChange={(l: string) => { this.setState({ currentLanguage: l }); }}
        >
          {productTag
            ? `Product Tag ${productTag.name ? `"${productTag.name}"` : ''}`
            : `Product Tags`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <Row>
            <Col md={24}>
              <FormItem label={'Internal name'} required={true}>
                <Input
                  name={'name'}
                  autoFocus={true}
                  placeholder="Internal name"
                  addonBefore={'Internal'}
                  defaultValue={productTag.name}
                  required={true}
                  onChange={e => this.onChange(e)}
                />
              </FormItem>
              <FormItem
                label={'Title'}
                required={true}
                extra={`For dynamic data, you can use :<br /> - <b>{discount}</b> for display product discount in percent format (output is -16%). Tags display when product has a discount`}
              >
                <Input
                  key={currentLanguage}
                  name={'title'}
                  addonBefore={currentLanguage}
                  defaultValue={(productTag.title || {})[currentLanguage]}
                  required={true}
                  onChange={e => this.onChange(e, currentLanguage)}
                />
              </FormItem>
              <FormItem label={'Tag color'} extra={'Default color setting. The tag can be visually suited using another color or graphic element'}>
                <ColorInput
                  name={'color'}
                  value={(productTag.color || '')}
                  onChange={e => this.onChange(e)}
                />
              </FormItem>
              <FormItem>
                <Checkbox
                  name={'active'}
                  checked={productTag.active !== null && productTag.active !== undefined ? productTag.active : true}
                  onChange={e => this.onChange(e)}
                >
                  Active
                </Checkbox>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>);
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);
    const newValue = (language
      ? { [name]: { ...this.state.productTag[name], [language]: inputValue } }
      : { [name]: inputValue });
    this.setState({
      productTag: { ...this.state.productTag, ...newValue }
    });
  }

  private async save() {
    const productTag = { ...this.state.productTag };
    this.props.onSave(productTag);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/ProductTag/ProductTagDetail/ProductTagDetail.tsx